import React from "react";
import { Notification } from "@telia/teddy";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../models";
import { getSalesAgent } from "../../state/selectors/selectors";
import CommissionNumbers from "../SuperAdmin/CommissionNumbers";

const Provisjon: React.FC = () => {
    const salesAgent = useSelector((state: RootState) => getSalesAgent(state));

    if (salesAgent?.isManager !== true) {
        return (
            <div className="retailer-dashboard-wrapper">
                <Notification type="tile" variant="error">
                    <Notification.Icon />
                    <Notification.Text>Kun butikksjef har tilgang til denne siden.</Notification.Text>
                </Notification>
            </div>
        );
    }

    return <CommissionNumbers mode="manager" />;
};

export default Provisjon;
